import { useSite } from "@/contexts/SiteContext";

// Conținutul editabil al unei secțiuni (din CMS/Live Editor)
export function useSectionContent(key) {
  const { sections } = useSite();
  return (sections || []).find((s) => s.key === key)?.content || {};
}
